module.exports = __webpack_public_path__ + "static/media/swap-dark.377e21dc.svg";